export default __webpack_public_path__ + "static/media/bounty.1ec98172.png";